import { render, staticRenderFns } from "./FullPageProgressBar.vue?vue&type=template&id=2d4e1e61&scoped=true&"
import script from "./FullPageProgressBar.vue?vue&type=script&lang=js&"
export * from "./FullPageProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./FullPageProgressBar.vue?vue&type=style&index=0&id=2d4e1e61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e1e61",
  null
  
)

export default component.exports